export const projectsSelector = (state: any) => state?.projects || {};
